<div class="custom-ag-header" [ngClass]="{'sort-enabled': params.enableSorting}">
  <div class="customHeaderLabel" placement="top" [pTooltip]="params.displayName" tooltipPosition="right"
       (click)="toggleSortOrder($event)" (touchstart)="toggleSortOrder($event)">
    {{ params.displayName | translate}}
  </div>
  <div *ngIf="params.enableSorting" (click)="onSortRequested('desc', $event)" [ngClass]="getSortOrderStatus('asc')"
       class="customSortDownLabel">
    <i pTooltip="{{'table.header.icon.title.sort-ascending'|translate}}" tooltipPosition="right">
      <svg class="icon">
        <use xlink:href="#icon-sort-ascending" /></svg>
      </i>
  </div>
  <div *ngIf="params.enableSorting" (click)="onSortRequested('asc', $event)" [ngClass]="getSortOrderStatus('desc')"
       class="customSortUpLabel">
      <i pTooltip="{{'table.header.icon.title.sort-descending'|translate}}" tooltipPosition="right">
        <svg class="icon">
          <use xlink:href="#icon-sort-descending" /></svg>
      </i>
  </div>
</div>
<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
  <symbol id="icon-sort-ascending" viewBox="0 0 20 20">
    <path d="M6.1 13.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 3.9c-0.4 0.4-0.4 1 0 1.4 0.2 0.3 0.4 0.4 0.7 0.4z"></path>
  </symbol>
  <symbol id="icon-sort-descending" viewBox="0 0 20 20">
    <path d="M13.2 7.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
  <symbol id="icon-sort">
    <path d="M6.1 8.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 4c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3z"></path>
    <path d="M13.2 12.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
</svg>
